<template>
	<AppDropdownMenu :right="!left" :left="left" bottom absolute min-width="265" :nudge-bottom="10" :items="optionsMenuItems">
		<template #activator="{}">
			<v-btn icon x-small rounded width="20" height="20" class="field-action-button">
				<SIcon class="menu-button" name="menu-button" width="20" />
			</v-btn>
		</template>
	</AppDropdownMenu>
</template>

<script>
import { moveWidgetFieldConfiguration } from '@/store/modules/widgetEditor/actions';
import { mapActions } from 'vuex';
export default {
	name: 'MoveConfigurationDropdown',
	props: {
		left: { type: Boolean },
		isGeneralConfiguration: { type: Boolean },
	},
	computed: {
		optionsMenuItems() {
			return [{ text: `Move to ${this.isGeneralConfiguration ? 'personal' : 'general'} setup`, onClick: this.onMoveField }];
		},
	},
	methods: {
		...mapActions([moveWidgetFieldConfiguration.fullPath]),
		onMoveField() {
			this[moveWidgetFieldConfiguration.fullPath](this.isGeneralConfiguration);
		},
	},
	data() {
		return {};
	},
};
</script>

<style scoped lang="scss">
.menu-button {
	margin-top: 3px;
	margin-right: 2px;
}
</style>
